module.exports = __webpack_public_path__ + "static/media/slider4.5724c711.jpg";